import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { getApiBaseUrl } from '../../apiBase';

/**
 * Загрузка APK на текущий сервер (wwwroot/downloads/SportProgress.apk).
 * После загрузки кнопка «Скачать APK» на сайте появляется автоматически (см. useApkInfo).
 */
export default function ApkUploadCard() {
    const { t } = useTranslation('adminConfig');
    const inputRef = useRef(null);
    const [info, setInfo] = useState(null);
    const [percent, setPercent] = useState(null);
    const [msg, setMsg] = useState(null);

    const loadInfo = useCallback(async () => {
        try {
            const r = await axios.get(`${getApiBaseUrl()}/download/apk-info`, { params: { _: Date.now() } });
            setInfo(r.data);
        } catch {
            setInfo(null);
        }
    }, []);

    useEffect(() => { loadInfo(); }, [loadInfo]);

    const onFile = async (e) => {
        const file = e.target.files && e.target.files[0];
        e.target.value = '';
        if (!file) return;
        if (!/\.apk$/i.test(file.name)) {
            setMsg({ ok: false, text: t('apkUploadInvalid') });
            return;
        }
        const form = new FormData();
        form.append('apk', file);
        setMsg(null);
        setPercent(0);
        try {
            const r = await axios.post(`${getApiBaseUrl()}/admin/download/upload-apk`, form, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                onUploadProgress: (ev) => {
                    if (ev.total) setPercent(Math.round((ev.loaded / ev.total) * 100));
                },
                maxBodyLength: Infinity,
                maxContentLength: Infinity,
                timeout: 0,
            });
            setMsg({ ok: true, text: t('apkUploadOk', { size: r.data?.sizeMb ?? '' }) });
            await loadInfo();
        } catch (err) {
            const status = err?.response?.status;
            setMsg({ ok: false, text: `${t('apkUploadFail')}${status ? ` (${status})` : ''}` });
        } finally {
            setPercent(null);
        }
    };

    const uploading = percent !== null;
    const updated = info?.updatedAt ? new Date(info.updatedAt).toLocaleString() : '';

    return (
        <div style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid var(--sp-border, #e2e8f0)' }}>
            <label>{t('apkUploadTitle')}</label>
            <input ref={inputRef} type="file" accept=".apk,application/vnd.android.package-archive" onChange={onFile} style={{ display: 'none' }} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginTop: 6 }}>
                <button
                    type="button"
                    className="sp-btn sp-btn--primary"
                    disabled={uploading}
                    onClick={() => inputRef.current && inputRef.current.click()}
                    style={{ minHeight: 40 }}
                >
                    {uploading ? t('apkUploading', { percent }) : `⬆️ ${t('apkUploadBtn')}`}
                </button>
            </div>
            {uploading && (
                <div style={{ height: 6, borderRadius: 3, background: '#e2e8f0', marginTop: 8, overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: `${percent}%`, background: '#34a853', transition: 'width .2s' }} />
                </div>
            )}
            {msg && (
                <div role="status" style={{ marginTop: 8, fontSize: 13, color: msg.ok ? '#166534' : '#b91c1c' }}>{msg.text}</div>
            )}
            <span className="hint" style={{ display: 'block', marginTop: 8 }}>
                {info?.androidAvailable
                    ? t('apkCurrent', { size: info.apkSizeMb, date: updated })
                    : t('apkNone')}
            </span>
            <span className="hint" style={{ display: 'block' }}>{t('apkUploadHint')}</span>
        </div>
    );
}
